import { Box, Typography, Button, Grid, Paper, CircularProgress } from '@mui/material';
import { OrganisationFormData } from '../../../../types/organization';
import { useEffect } from 'react';

interface SummaryViewProps {
  data: OrganisationFormData;
  onSubmit: () => void;
  onBack: () => void;
  isLoading: boolean;
}

const SummarySection = ({ title, data }: { title: string; data: Record<string, any> }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="subtitle1" color="primary" sx={{ mb: 2 }}>
      {title}
    </Typography>
    <Grid container spacing={2}>
      {Object.entries(data).map(([key, value]) => (
        <Grid item xs={12} sm={6} key={key}>
          <Typography variant="caption" color="text.secondary" display="block">
            {key.charAt(0).toUpperCase() + key.slice(1)}
          </Typography>
          <Typography variant="body2">
            {typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value || 'Not provided'}
          </Typography>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default function SummaryView({ data, onSubmit, onBack, isLoading }: SummaryViewProps) {
  useEffect(() => {}, [data]);

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Summary
      </Typography>

      <Paper variant="outlined" sx={{ p: 3, mb: 3 }}>
        <SummarySection title="Client Information" data={data.client} />
        <SummarySection title="Company Details" data={data.company} />
        <SummarySection
          title="Subscription Details"
          data={{
            planType: data.planType,
            isBookingEnabled: data.isBookingEnabled,
            resourceProfession: data.resourceProfessional,
            bookingDescription: data.bookingDescription,
          }}
        />
      </Paper>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
        <Button onClick={onBack}>Back</Button>
        <Button
          variant="contained"
          disableElevation
          onClick={onSubmit}
          disabled={isLoading}
          startIcon={isLoading && <CircularProgress size={20} />}
          sx={{ minWidth: 120 }}
        >
          {isLoading ? 'Submitting...' : 'Submit'}
        </Button>
      </Box>
    </Box>
  );
}
